"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lifecycle = require("../lifecycle");

var MAX_RETENTION = 5;
/**
 * Use lifecycle phase triggers to keep track of running commands and associate
 * them with users
 */

var jobsPlugin = function jobsPlugin(_ref) {
  var _ref9;

  var jobService = _ref.jobService;
  var namespace = 'core.plugin.job';
  return _ref9 = {}, _defineProperty(_ref9, _lifecycle.phaseEnum.LISTEN, {
    exit: function exit(_ref2) {
      var context = _ref2.context,
          state = _ref2.state;
      var id = context.message.user.id;
      var job = jobService.create(id, {
        context: context
      });
      state.set("".concat(namespace, ".job"), job);
    }
  }), _defineProperty(_ref9, _lifecycle.phaseEnum.PROCESS, {
    exit: function exit(_ref3) {
      var source = _ref3.source,
          state = _ref3.state;
      var job = state.get("".concat(namespace, ".job"));
      jobService.update(job.id, {
        source: source
      });
    }
  }), _defineProperty(_ref9, _lifecycle.phaseEnum.EXECUTE, {
    enter: function enter(_ref4) {
      var command = _ref4.command,
          state = _ref4.state;
      var job = state.get("".concat(namespace, ".job"));
      jobService.update(job.id, {
        command: command,
        // command can be linked back to job by command.id
        status: jobService.status.RUNNING
      });
    },
    exit: function exit(_ref5) {
      var output = _ref5.output,
          state = _ref5.state;
      var job = state.get("".concat(namespace, ".job"));
      jobService.update(job.id, {
        status: jobService.status.FULFILLED,
        output: output,
        finished: Date.now()
      }); // cleanup

      jobService.find({
        status: jobService.status.FULFILLED
      }).then(function (fulfilledJobs) {
        if (fulfilledJobs.length > MAX_RETENTION) {
          fulfilledJobs.forEach(function (_ref6, index) {
            var id = _ref6.id;
            return index < fulfilledJobs.length - MAX_RETENTION && jobService.destroy(id);
          });
        }
      });
    },
    error: function error(err, _ref7) {
      var state = _ref7.state;
      var job = state.get("".concat(namespace, ".job"));
      jobService.update(job.id, {
        status: jobService.status.REJECTED,
        finished: Date.now()
      }); // cleanup

      jobService.find({
        status: jobService.status.REJECTED
      }).then(function (rejectedJobs) {
        if (rejectedJobs.length > MAX_RETENTION) {
          rejectedJobs.forEach(function (_ref8, index) {
            var id = _ref8.id;
            return index < rejectedJobs.length - MAX_RETENTION && jobService.destroy(id);
          });
        }
      });
    }
  }), _ref9;
};

var _default = jobsPlugin;
exports.default = _default;